import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { RegexConstants } from '../RegexConstants';
import { RepairCodeExclusionDetailView } from '../models/repair-code-exclusion-detail-view.model';
import { RepairCodeExclusionFormValue } from '../form-model/create-repair-code-exclusion.form.model';
import { CreateRepairCodeExclusionRequest } from '../models/create-repair-code-exclusion-request.model';

export function addExclusionFormControls(form: FormGroup, formBuilder: FormBuilder): void {
  form.addControl('repairMode', formBuilder.nonNullable.control<string>('', [Validators.required]));
  form.addControl(
    'repairCode',
    formBuilder.nonNullable.control<string>('', [Validators.required, Validators.pattern(RegexConstants.REPAIR_CODE)]),
  );
  form.addControl('description', formBuilder.nonNullable.control<string>(''));
  form.addControl('exclusiveRepairCodes', formBuilder.nonNullable.control<string>('', [Validators.required]));
  form.addControl('exclusiveRepairCodeInput', formBuilder.nonNullable.control<string>(''));
}

export function parseExclusiveRepairCodes(value: string | null | undefined): string[] {
  return (value || '')
    .split(',')
    .map((code) => code.trim())
    .filter(Boolean);
}

export function populateExclusionForm(form: FormGroup, data: RepairCodeExclusionDetailView): string[] {
  const exclusiveRepairCodes = parseExclusiveRepairCodes(data.exclusiveRepairCodes);
  form.patchValue({
    repairMode: data.repairMode,
    repairCode: data.repairCode,
    description: data.description,
    exclusiveRepairCodes: exclusiveRepairCodes.join(','),
    exclusiveRepairCodeInput: '',
  });
  form.markAsPristine();
  return exclusiveRepairCodes;
}

export function createExclusionRequest(value: RepairCodeExclusionFormValue): CreateRepairCodeExclusionRequest {
  return {
    repairMode: value.repairMode,
    repairCode: value.repairCode,
    exclusiveRepairCodes: value.exclusiveRepairCodes,
  };
}

export function createExclusionUpdate(value: RepairCodeExclusionFormValue): { exclusiveRepairCodes: string } {
  return { exclusiveRepairCodes: value.exclusiveRepairCodes };
}

export function getExclusionSubmitError(error: HttpErrorResponse | null, operation: string): { messages: string[]; toast: string } {
  const genericMessage = `Failed to ${operation} repair code exclusion. Please try again.`;
  if (!error) return { messages: [genericMessage], toast: genericMessage };
  if (error.status === 400)
    return { messages: ['Invalid data. Please check your inputs.'], toast: 'Invalid data. Please check your inputs.' };
  if (error.status === 409) return { messages: ['This exclusion already exists.'], toast: 'This exclusion already exists.' };
  if (error.status === 422 && error.error?.violations) {
    return {
      messages: error.error.violations.map((violation: { message: string }) => violation.message),
      toast: 'Validation errors occurred. Please check the form.',
    };
  }
  return { messages: [genericMessage], toast: genericMessage };
}
